<template>
    <!-- 会员信息和中奖记录（共用） -->
    <div class="member-style">
        <!-- 查询到会员信息时，才显示积分情况 -->
        <div v-if="Object.keys(memberInfo).length !== 0 "
            class="member-info"
            :style="{'background': bigWheelActivityType == blindBox || tigerLottery ? '#FFF' : '#ffffff92'}">
            <div class="points">您的剩余积分：<span>{{ pointsValue }}</span></div>
        </div>
        <!-- 中奖记录条数大于0时显示 -->
        <div v-if="myRecords.length>0"
            class="winning-info"
            :style="{'padding-top': memberInfo ? '0' : '20px'}">
            <!-- 活动为大转盘时，bigWheelActivityType：1 大转盘，2 盲盒， 3 轮盘锦鲤（tigerLottery=true） -->
            <p v-if="bigWheelActivityType == bigTurnable"
                style="width:100%;text-align: center;padding-top: 20px">
                <span style="font-size: 18px;color: #000000;text-align: center;font-weight: 600;">我的中奖记录</span>
            </p>
            <!-- 活动为盲盒或轮盘锦鲤时 -->
            <div v-if="bigWheelActivityType == blindBox || tigerLottery"
                :class="tigerLottery ? 'tiger-prizes-title' : 'blindBox-prizes-title' "
                class="blindBox-info-title"
                :style="{'color': sectionThreeColor}">
                <div>我的中奖记录</div>
            </div>
            <!-- 奖品列表 -->
            <div class="list">
                <ul style="max-height: 180px; overflow-y: auto;">
                    <li v-for="(item,index) in myRecords"
                        :key="index">
                        <!-- 中奖时间 -->
                        <div class="listItemLeft">
                            {{ item.creationDate.slice(0,10) }}
                        </div>
                        <!-- 积分 | 奖品名称 -->
                        <div class="ellipsis listItemCenter">
                            <span v-if="item.rewardType == accumulatePoints">{{ item.pointValue }}积分</span>
                            <span v-else>{{ item.rewardName }}</span>
                        </div>
                        <div class="listItemRight">
                            <!-- 查看按钮，奖品为积分时不显示 -->
                            <template v-if="item.rewardType != accumulatePoints">
                                <!-- 大转盘 -->
                                <span v-if="bigWheelActivityType == bigTurnable"
                                    class="actionBtn"
                                    @click="viewRecord(item)">查看</span>
                                <!-- 盲盒或轮盘锦鲤 -->
                                <span v-if="bigWheelActivityType == blindBox || tigerLottery"
                                    :style="{'background': sectionThreeColor}"
                                    :class="tigerLottery ? 'tiger-btn' : 'blindBox-btn'"
                                    class="blindBox-info-btn"
                                    @click="viewRecord(item)">查看</span>
                            </template>
                            <!-- 奖品为积分，且配置了自定义链接跳转时 -->
                            <div v-if="isShowPointsBtn(item)">
                              <span v-if="bigWheelActivityType == bigTurnable" 
                                    class="actionBtn"
                                    @click="nextStep(item)">去使用</span>
                              <span v-if="bigWheelActivityType == blindBox || tigerLottery"
                                    :style="{'background': sectionThreeColor}"
                                    :class="tigerLottery ? 'tiger-btn' : 'blindBox-btn'"
                                    class="blindBox-info-btn"
                                    @click="nextStep(item)">去使用</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import { BigWheelConstants as BWC } from '../common/global-variable';
export default {
  props: {
    memberInfo: Object,
    bigWheelActivityType: String,
    tigerLottery: Boolean,
    sectionThreeColor: String,
    pointsValue: { type: String, default: '0' },
    myRecords: Array
  },
  data(){
    return {
      // 积分奖品
      accumulatePoints: BWC.GoodsType.accumulatePoints,
      // 大转盘
      bigTurnable: BWC.BigWheelActivityType.bigTurnable,
      // 盲盒
      blindBox: BWC.BigWheelActivityType.blindBox
    }
  },
  methods: {
    viewRecord(item) {
      this.$emit('viewRecord', item);
    },
    // 是否展示积分按钮
    isShowPointsBtn(item) {
      return item.rewardType === BWC.GoodsType.accumulatePoints && item.jumpType === BWC.JumpType.customLink;
    },
    // 跳转下级页面
    nextStep(item){
      this.$emit('nextStep', item.jumpUrl, item.jumpType)
    }
  }
};
</script>
<style lang="scss" scoped>
.member-style {
  width: 91.2%;
  margin: 0 auto 10px;
  border-radius: 10px;
  overflow: hidden;

  .member-info {
    background: #ffffff92;
    width: 100%;
    height: 30px;
    padding: 20px 10px 20px;
    font-size: 14px;
    color: #000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .tiger-member-info-nickname {
      margin-top: 20px;
      margin-left: 10px;
      padding-bottom: 15px;
    }
    .tiger-member-info-points {
      margin-top: 20px;
      margin-right: 10px;
      padding-bottom: 15px;
    }
    div {
      width: 50%;
      text-align: left;

      span {
        font-size: 16px;
        color: #ff6b22;
      }
    }

    div:nth-child(2) {
      text-align: right;
    }
    .points {
      width: 300px;
    }
  }

  .winning-info {
    background: #fff;
    padding: 20px 10px 20px;
  }
}
.list {
  margin-top: 15px;
  font-size: 14px;
  max-height: 180px;
  color: #333333;
  overflow: hidden;
}

.list ul {
  width: 110%;
  padding-right: 10%;
}

.list li {
  display: flex;
  line-height: 36px;
}

.listItemLeft {
  width: 80px;
}

.listItemRight {
  width: 60px;
  text-align: end;
}

.listItemCenter {
  text-align: center;
  flex: 1;

  span {
    text-align: center;
  }
}
.blindBox-info-btn {
  font-family: HYQiHei-EZS;
  font-size: 12px;

  font-weight: 400;
  text-align: center;
  line-height: 28px;
  padding: 4px 12px;
  border-radius: 15px;
}
.actionBtn {
  color: #2592f7;
  border: 1px solid #2592f7;
  text-align: center;
  line-height: 28px;
  padding: 2px 10px 1px;
  border-radius: 15px;
  font-size: 12px;
}
.blindBox-info-title {
  width: 100%;
  height: 20px;
  font-family: HYQiHei-FZS;
  font-size: 16px;
  font-weight: 400;
  position: relative;

  div {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &::before {
      content: '';
      width: 40px;
      height: 3px;
      position: absolute;
      top: 50%;
      left: -60px;
    }

    &::after {
      content: '';
      width: 40px;
      height: 3px;
      position: absolute;
      top: 50%;
      right: -60px;
    }
  }
}
.blindBox-btn {
  background-image: linear-gradient(116deg, #fff8e9 0%, #f2ddb4 95%);
  color: #c79f60;
}
.tiger-prizes-title{
  color: #ae2c40;
  div {
    &::before {
      background: linear-gradient(to right, transparent, #d7324c);
    }
    &::after {
      background: linear-gradient(to right, #d7324c, transparent);
    }
  }
}
.blindBox-prizes-title {
  color: #b27d13;
  div {
    &::before {
      background: linear-gradient(to right, transparent, #b27d13);
    }
    &::after {
      background: linear-gradient(to right, #b27d13, transparent);
    }
  }
}
.tiger-btn {
  color: #ffffff;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/components/member-and-winning.vue